import { connect } from 'react-redux';
import { flow } from 'lodash';
import { withRouter } from 'react-router-dom';
import App from './App';
import { storeFarthestPath, storePaths } from '../../store/path';
import { initializeUser } from '../../store/user';

const mapStateToProps = state => ({
  paths: state.path.paths,
  farthestPath: state.path.farthestPath
});

const mapDispatchToProps = dispatch => ({
  onMount: (paths, farthestPath) => {
    dispatch(dispatch => {
      dispatch(storePaths(paths));
      dispatch(storeFarthestPath(farthestPath));
      dispatch(initializeUser());
    });
  },
  storeFarthestPath: farthestPath => {
    dispatch(storeFarthestPath(farthestPath));
  }
});

export default flow(connect(mapStateToProps, mapDispatchToProps), withRouter)(
  App
);



// WEBPACK FOOTER //
// ../core/src/components/App/index.js